import { mapMutations } from 'vuex'
export default{
    mounted () {
        // console.log('this.pageMixin_index',this.pageMixin_index);
        this.setCurretMenuIndex(this.pageMixin_index)
    },
    methods: {
        ...mapMutations(['setCurretMenuIndex']),
    }
}